import {
    Component,
    EventEmitter,
    HostBinding,
    HostListener,
    Input,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Log } from "ng2-logger";
import {ResolutionService} from "@services/resolution.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
    selector: 'app-confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {
    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
    @HostBinding('class.mobile') isMobile = false;


    @Input() title: string;
    @Input() question: string;
    @Input() message: string;
    @Input() displayReasonMode: boolean;
    @Input() displayReasonLabel: string;
    @Input() displayReasonPlaceholder: string;
    @Input() confirmOnlyMode: boolean;
    @Input() reasonMandatory = false;
    @Input() isConfirmationInProgress = false;
    @Input() removeOverlay = false;
    @Input() confirmWithReason = false;
    @Input() isCustomContent = false;
    @Input() confirmButtonDisabled = false;
    @Input() showConfirmButton = true;
    @Input() isError = false;

    @Output() scanEvent = new EventEmitter<any>();
    @Output() invalidBadge = new EventEmitter<any>();
    @Output() confirmEvent = new EventEmitter<any>();

    formGroup: UntypedFormGroup;
    focused = true;
    scanInput = '';
    showErrors = false;
    param = null;
    _logger = Log.create(ConfirmationModalComponent.name);


    constructor(private resolutionService: ResolutionService) {
        this.resolutionService.screenSize$.pipe(untilDestroyed(this)).subscribe(screen => {
            this.isMobile = screen.mobile;
        })
    }

    ngOnInit() {
        this.formGroup = new UntypedFormGroup({
            'reason': new UntypedFormControl('', Validators.required),
        });
    }

    open(param = null) {
        if (this.reasonMandatory) {
            this.formGroup.reset({reason: ''});
        }
        this.showErrors = false;
        this.param = param;
        this.modal.open();

        if (this.removeOverlay) {
            setTimeout(() => {
                const overlay = document.getElementsByClassName('modal-overlay');
                if (overlay.length > 1) {
                    overlay[1].classList.add('z-minus');
                }
            });
        }
    }

    close() {
        this.modal.close();
        this.isConfirmationInProgress = false;
        this.formGroup?.reset();
    }

    onCancel() {
        this.close();
    }

    onScan(boschId: string) {
        this._logger.info('ConfirmationModalComponent:: boschId: ' + boschId);

        this.isConfirmationInProgress = true;
        this.scanInput = boschId;
        this.scanEvent.emit({reason: this.formGroup.value.reason, boschId: boschId, param: this.param});
    }

    onInvalidBadge(badgeId: string) {
        this._logger.info('ConfirmationModalComponent:: Badge input is not valid');
        this.invalidBadge.emit(badgeId);
    }


    onConfirmEvent() {
        this.confirmEvent.emit(this.param);
    }

    onConfirmReason() {
        if (this.formGroup.invalid) {
            this.showErrors = true;
            return;
        }

        if (this.confirmWithReason) {
            this.confirmEvent.emit(this.formGroup.value.reason);
        } else {
            this.displayReasonMode = false;
        }
    }

    @HostListener('window:focus', ['$event'])
    onFocus() {
        this.focused = true;
    }

    @HostListener('window:blur', ['$event'])
    onBlur() {
        this.focused = false;
    }
}
